/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { MailingListsSummaryDto as FeatureMailingListsMailingListsSummaryDto } from '../models/feature/mailing-lists/mailing-lists-summary-dto';
import { getSummary } from '../fn/mailing-lists-page/get-summary';
import { GetSummary$Params } from '../fn/mailing-lists-page/get-summary';

@Injectable({ providedIn: 'root' })
export class MailingListsPageClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mailingListsPageGetSummary()` */
  static readonly MailingListsPageGetSummaryPath = '/mailing-lists-page';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSummary$Response(context?: HttpContext): Observable<StrictHttpResponse<FeatureMailingListsMailingListsSummaryDto>> {
    const obs = getSummary(this.http, this.rootUrl, {} satisfies GetSummary$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSummary(context?: HttpContext): Observable<FeatureMailingListsMailingListsSummaryDto> {
    const resp = this.getSummary$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<FeatureMailingListsMailingListsSummaryDto>): FeatureMailingListsMailingListsSummaryDto => r.body)
    );
  }

}
